var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 64,
    viewBox: "0 0 46 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.81 16.91L29.06 1.19C28.61 0.74 28.16 0.5 27.5 0.5H5C2.54 0.5 0.5 2.51 0.5 5V59C0.5 61.49 2.54 63.5 5 63.5H41C43.49 63.5 45.5 61.49 45.5 59V18.5C45.5 17.84 45.26 17.36 44.81 16.91ZM27.5 5.9L40.1 18.5H27.5V5.9ZM41 59H5V5H23V18.5C23 20.96 25.04 23 27.5 23H41V59Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 45.5H9.5V50H36.5V45.5Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 32H9.5V36.5H36.5V32Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogs);
export default __webpack_public_path__ + "static/media/ic-logs.a0d762048013aac528486e4f72297852.svg";
export { ForwardRef as ReactComponent };